import Vue from 'vue';

import {
  Row,
  Col,
  Button,
  Link,
  Loading,
  Divider,
  Collapse,
  CollapseItem,
  Tag,
  Icon,
  Descriptions,
  DescriptionsItem,
  Upload,
  Table,
  TableColumn,
  Calendar,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en';
// 设置语言
Vue.use(lang);

// 引入组件
Vue.use(Calendar);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Button);
Vue.use(Tag);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Upload);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
